<template>
  <ModalVue :modal-active="isOpen" @close="closeModal" isFilterModal maxWidth="max-w-[600px]">
    <template #header>
      <h3 class="text-lg font-bold text-textPrimary text-left">Exportar relatório .xlsx</h3>
    </template>

    <div class="text-left mt-[-16px] text-textPrimary">
      <p class="mb-6">
        O relatório em formato de planilha será exportado com as configurações de visualização
        selecionadas.
      </p>

      <div class="mb-6">
        <div class="flex items-center mb-3 gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9ZM12 4.5C17 4.5 21.27 7.61 23 12C21.27 16.39 17 19.5 12 19.5C7 19.5 2.73 16.39 1 12C2.73 7.61 7 4.5 12 4.5ZM3.18 12C4.83 15.36 8.24 17.5 12 17.5C15.76 17.5 19.17 15.36 20.82 12C19.17 8.64 15.76 6.5 12 6.5C8.24 6.5 4.83 8.64 3.18 12Z"
              fill="#323232"
            />
          </svg>
          <h4 class="font-semibold">Grupos de colunas</h4>
        </div>
        <div class="flex flex-wrap gap-2">
          <span
            v-for="group in columnGroups"
            :key="group"
            class="px-3 py-0.5 text-sm bg-gray-200 text-gray-800 rounded-full"
          >
            {{ group }}
          </span>
        </div>
      </div>

      <div>
        <div class="flex items-center mb-3 gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M14.9999 19.88C15.0399 20.18 14.9399 20.5 14.7099 20.71C14.3199 21.1 13.6899 21.1 13.2999 20.71L9.28986 16.7C9.05986 16.47 8.95986 16.16 8.99986 15.87V10.75L4.20986 4.62C3.86986 4.19 3.94986 3.56 4.37986 3.22C4.56986 3.08 4.77986 3 4.99986 3H18.9999C19.2199 3 19.4299 3.08 19.6199 3.22C20.0499 3.56 20.1299 4.19 19.7899 4.62L14.9999 10.75V19.88ZM7.03986 5L10.9999 10.06V15.58L12.9999 17.58V10.05L16.9599 5H7.03986Z"
              fill="#323232"
            />
          </svg>
          <h4 class="font-semibold">Filtros</h4>
        </div>
        <div v-if="activeFilters.length > 0" class="flex flex-wrap gap-2">
          <span
            v-for="filter in activeFilters"
            :key="filter.label"
            class="px-3 py-2 text-sm border border-[#2F7F91] text-[#2F7F91] rounded-full font-bold"
          >
            {{ filter.label }}:
            <span class="font-normal">
              {{
                filter.value === true ? 'Sim' : filter.value === false ? 'Não' : filter.value
              }}</span
            >
          </span>
        </div>
        <p v-else class="text-sm text-gray-500">Nenhum filtro adicional aplicado.</p>
      </div>
    </div>

    <template #footer>
      <div class="flex justify-between w-full">
        <OutlinedButton text="Cancelar" @click="closeModal" width="100px" height="48px" />
        <FilledButton
          text="Exportar"
          @click="handleConfirmExport"
          width="100px"
          height="48px"
          class="!bg-primary30"
          :loading="isLoadingBtn"
        />
      </div>
    </template>
  </ModalVue>
</template>

<script setup lang="ts">
import { PropType, ref } from 'vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import { ReportXlxsRequest } from '@/Network/Services/ReportsService'

const isLoadingBtn = ref(false)

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true
  },
  columnGroups: {
    type: Array as PropType<string[]>,
    required: true
  },
  activeFilters: {
    type: Array as PropType<{ value: any; label: string }[]>,
    required: true
  },
  rawFilters: {
    type: Object as PropType<ReportXlxsRequest>,
    required: true
  }
})

const emit = defineEmits<{
  (e: 'update:isOpen', value: boolean): void
  (e: 'confirm', payload: ReportXlxsRequest): void
}>()

function closeModal() {
  emit('update:isOpen', false)
}

function handleConfirmExport() {
  const payload: ReportXlxsRequest = {
    ...props.rawFilters
  }

  emit('confirm', payload)
  closeModal()
}
</script>
